module.exports = __webpack_public_path__ + "7bfccff761f745f7da8bcbaa01faa7a0.MP3";